var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dashboard-page-title',{attrs:{"showAddBtn":false,"showFilter":false,"showSearch":true,"showExportation":true}},[_vm._v("الحجوزات")]),_c('main-table',{attrs:{"fields":_vm.fields,"query":"&status=active","list_url":"doctor/reservations"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }